import axios from "axios";

export class CouponService
{
	public ApplyCoupon = (couponCode: string): Promise<any> =>
	{
		const apiUrl = `/api/carts/?coupon-code=${couponCode}`;

		return axios.post(apiUrl)
			.catch((error) =>
			{
				console.log(error);
			});
	};

	public RemoveCoupon = (): Promise<any> =>
	{
		const apiUrl = "/api/carts/?remove-coupon=true";

		return axios.post(apiUrl)
			.catch((error) =>
			{
				console.log(error);
			});
	};
}